import { render, staticRenderFns } from "./workflow_design_edit.vue?vue&type=template&id=07960034&scoped=true"
import script from "./workflow_design_edit.vue?vue&type=script&lang=js"
export * from "./workflow_design_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07960034",
  null
  
)

export default component.exports